/**
 * Analytics seam. Events are a closed, typed dictionary so product analytics
 * never drift between platforms. Implementations: PostHog on web
 * (`posthog-js`) and native (`posthog-react-native`); `noopAnalytics` until keys
 * are configured.
 */
export type AnalyticsEvent =
  | { name: 'app_opened' }
  | { name: 'sign_in_started'; channel: 'email' | 'phone' | 'apple' | 'google' }
  | { name: 'sign_in_completed' }
  | { name: 'profile_completed' }
  | { name: 'exercise_started'; kind: 'reading' | 'writing' | 'math' }
  | { name: 'exercise_completed'; kind: 'reading' | 'writing' | 'math'; seconds: number }
  | { name: 'routine_completed'; streak: number }
  | { name: 'invite_sent'; via: 'sms' | 'email' | 'link' };

export interface Analytics {
  track(event: AnalyticsEvent): void;
  identify(userId: string, traits?: Record<string, string | number | boolean>): void;
  reset(): void;
}

export const noopAnalytics: Analytics = {
  track() {},
  identify() {},
  reset() {},
};
